// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ju-2";
export var chatLink = "_ju-0";
export var chatText = "_ju-1";